<template>
    <div class="admin-page-content-in admin-page-jokes" v-if="weekDBarr.length > 0">
        <div class="container">
            <div class="page-title">
                <h1>Розыгрыши</h1>
                <div class="user-name-title">
                    <span>Вы авторизованы как:</span>
                    <strong>{{adminData.user.email}}</strong>
                </div>
            </div>
            <!-- {{ adminData.user.role }} -->
            <div class="jokes-content-container">
                <div class="page-navigation">
                    <ul>
                        <li v-for="item in weekDBarr" :class="{'active' : item.week_ID == current_week}">
                            <button class="btn-week" @click="item.week_ID == 5 ? getMainEventData(item.week_ID) : getDataByWeek(item.week_ID)"><span>{{ item.name }}</span></button>
                        </li>
                    </ul>
                </div>
                <div class="jokes-function-container">
                    <div class="date-info">
                        <strong>с<span> {{ counteDateFrom }}</span> по <span>{{ counteDateTo }}</span></strong>
                    </div>
                    <div class="jokes-stat">
                        <ul>
                            <li>
                                <span>Кол-во зарегистрированных кодов:</span>
                                <strong>{{ codesPerWeekCount }}</strong>
                            </li>
                            <li v-if="current_week == 5">
                                <span>Кол-во кодов (корректировка):</span>
                                <strong>{{ codesPerWeekCount_coorect }}</strong>
                            </li>
                            <li>
                                <span>Кол-во пользователей:</span>
                                <strong>{{ usersPerWeekCount }}</strong>
                            </li>
                        </ul>
                    </div>
                    <div class="btns-group" v-if="!weekDBarr[current_week_index].moved_next && adminData.user.role == 'editor'">
                        <button class="btn-joke-init" @click="current_week !== 5 ? initJokeWeek() : initJokeMain()" v-if="!weekDBarr[current_week_index].completed && usersPerWeekCount > 0 && !weekDBarr[current_week_index].saved_result" :class="{'activate' : usersPerWeekCount >= usersCountMin}">
                            <span v-if="draftWinnerDesck == null">Провести еженедельный розыгрыш</span>
                            <span v-else>Повторить розыгрыш</span>
                        </button>
                        <button class="btn-joke-save-pre" @click="saveJokeRes_PRE" v-if="!weekDBarr[current_week_index].completed && usersPerWeekCount > 0 && draftWinnerDesck != null && !weekDBarr[current_week_index].saved_result">
                            <span>Сохранить розыгрыш</span>
                        </button>
                        <button class="btn-joke-moved" @click="movedJokeWeek(weekDBarr[current_week_index].week_ID)" v-if="usersPerWeekCount < usersCountMin && draftWinnerDesck == null && !weekDBarr[current_week_index].completed && weekDBarr[current_week_index].week_ID < 4">
                            <span>Перенести розыгрыш</span>
                        </button>
                        <button class="btn-joke-save" @click="saveJokeResult" v-if="draftWinnerDesck != null && !weekDBarr[current_week_index].completed && weekDBarr[current_week_index].saved_result">
                            <span>Принять итоги розыгрыша и опубликовать</span>
                        </button>
                        <div class="anounce anounce-rules" v-if="!weekDBarr[current_week_index].completed && usersPerWeekCount < usersCountMin">
                            <p>* По правилам розыгрыша, функция проведения розыгрыша недоступна, пока число еженедльных участников меньше 21</p>
                            <p>* Для более четкого распределения резервных победителей, желательное число еженедльных участников должно быть больше минимума в 3 раза</p>
                            <p>* Учтите при переносе розыгрыша, в следующей неделе минимальное кол-во участников, должно превышать 42, в противном случае розыгрыш не состоится</p>
                        </div>
                        <div class="anounce" v-if="draftWinnerDesck == null && usersPerWeekCount >= usersCountMin">
                            <p>* Розыгрыш происходит автоматически, система случайно выберает победителей и так же случайно присвоит призы</p>
                            <p>* После нажатия кнопки "Провести еженедльный розыгрыш" ожидайте результатов и не закрывайте окно браузера</p>
                            <p>* Результаты еженедльного розыгрыша будут отображены в сводной таблице ниже</p>
                        </div>
                    </div>
                    <div class="moved-desc" v-if="weekDBarr[current_week_index].moved_next">
                        <p>Розыгрыш в данной неделе, был перенесен на следующую неделю</p>
                        <p>Дата переноса: {{ weekDBarr[current_week_index].moved_date }}</p>
                    </div>
                    <div class="winners-desc" v-if="draftWinnerDesck != null">
                        <h2>Результаты розыгрыша - {{ current_week }} Неделя <strong class="date-joke">Дата публикации: <span v-if="weekDBarr[current_week_index].completed">{{ weekDBarr[current_week_index].completed_date }}</span></strong></h2>
                        <div class="winners-items">
                            <div class="item" v-for="(item, index) in draftWinnerDesck">
                                <strong class="item-title">Победитель № {{ index + 1 }}</strong>
                                <div class="prize-info">
                                    <strong>Приз:</strong>
                                    <h5>{{ item.prize }}</h5>
                                </div>
                                <div class="winner-info">
                                    <h5>Основной победитель</h5>
                                    <ul>
                                        <li>
                                            <div class="info-label">Code</div>
                                            <div class="info-value">{{ item.code.code }}</div>
                                        </li>
                                        <li>
                                            <div class="info-label">ID</div>
                                            <div class="info-value">{{ item.code.userID }}</div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="rezerve-codes-info">
                                    <h5>Резервные победители</h5>
                                    <div class="code-item" v-for="(code, index) in item.reserveCodes">
                                        <strong>Резерв # {{ index + 1 }}</strong>
                                        <ul>
                                            <li>
                                                <div class="info-label">Code</div>
                                                <div class="info-value">{{ code.code }}</div>
                                            </li>
                                            <li>
                                                <div class="info-label">ID</div>
                                                <div class="info-value">{{ code.userID }}</div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- {{ codesOrderedArr }} -->
                    <!-- {{ usersOrderArr }} -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import { getCountFromServer, collection, query, doc, where, setDoc, getDoc, getDocs, updateDoc, arrayUnion } from "firebase/firestore"; 
    const moment = require('moment')
    export default {
        name: 'admin--page-jokes',
        components: {
            // svgIcon,
        },
        data () {
            return {
                codesOrderedArr: [],
                usersOrderArr: [],
                codesPerWeekCount: 0,
                codesPerWeekCount_coorect: 0,
                usersPerWeekCount: 0,
                usersCountMin: 21,
                draftWinnerDesck: null,
                hideOtherWeeksContent: false,
                counteDateFrom: '',
                counteDateTo: '',
                startDate: '2024-04-01', // Начальная дата в формате YYYY-MM-DD
                endDate: '2024-04-30', // Конечная дата в формате YYYY-MM-DD
                current_week: 1,
                current_week_index: 0,
                weekDBarr: [],
                pageNav: [
                    {
                        name: '1 НЕДЕЛЯ',
                        week: 1
                    },
                    {
                        name: '2 НЕДЕЛЯ',
                        week: 2
                    },
                    {
                        name: '3 НЕДЕЛЯ',
                        week: 3
                    },
                    {
                        name: '4 НЕДЕЛЯ',
                        week: 4
                    },
                    {
                        name: '5 НЕДЕЛЯ',
                        week: 5
                    },
                ],
                prizePool: [
                    'Сертификат на 10 тысяч тенге в Magnum',
                    'Сертификат на 20 тысяч тенге в Magnum',
                    'Кухонный робот BORK',
                ],
                prizePollMain: [
                    'Главный приз - Поездка во францию'
                ],
            }
        },
        computed: mapGetters({
            adminData: 'loadAdminDataStore',
        }),
        methods: {
            // Сборка данных и их обработка
            getDataByWeek(week) {
                this.current_week = week;
                this.current_week_index = this.current_week - 1;
                if (this.weekDBarr[this.current_week_index].completed || this.weekDBarr[this.current_week_index].saved_result) {
                    if (this.weekDBarr[this.current_week_index].winners_result != undefined) {
                        this.draftWinnerDesck = this.weekDBarr[this.current_week_index].winners_result;
                    }
                } else {
                    this.draftWinnerDesck = null;
                }
                // console.log(this.weekDBarr[this.current_week_index].winners_result, 'WINNERS DESC RESULT')
                this.getDateRange();
            },
            async getWeeksFromDB() {
                const weeks = [];
                const querySnapshot = await getDocs(collection(this.$db, "jokes"));
                querySnapshot.forEach((doc) => {
                    weeks.push(doc.data());
                    // doc.data() is never undefined for query doc snapshots
                    // console.log(doc.id, " => ", doc.data());
                });
                weeks.sort((a, b) => a.week_ID - b.week_ID);
                this.weekDBarr = weeks;
                this.current_week = this.getCurrentWeek(this.startDate);
                if (this.current_week < 5) {
                    this.getDataByWeek(this.current_week);
                } else {
                    this.getMainEventData(this.current_week);
                }
                // console.log(this.weekDBarr)
            },
            getCurrentWeek(startDate) {
                const currentDate = new Date(); // Получить текущую дату
                const startDateObject = new Date(startDate); // Преобразовать начальную дату в объект Date
                const difference = currentDate - startDateObject; // Разница в миллисекундах между текущей датой и начальной датой
                const weeksDifference = Math.floor(difference / (1000 * 60 * 60 * 24 * 7)); // Количество недель между датами
                if (weeksDifference + 1 > 5) {
                    return 5
                } else if (weeksDifference + 1 < 0 || weeksDifference + 1 == 0 || weeksDifference + 1 > 0 && weeksDifference + 1 < 1) {
                    return 1
                } else {
                    return weeksDifference + 1; // +1, так как первая неделя будет нумероваться как 1, а не 0
                }
            },
            getDateRange() {
                // Задаем входные параметры
                const startDate = this.startDate;
                const selectedWeek = this.current_week; // Выбранная неделя
                const daysInWeek = 7; // Количество дней в неделе
                // Получаем массив transferred_from текущей недели
                const transferredFromIds = this.weekDBarr[this.current_week_index].transferred_from || [];
                // Вычисляем начальную дату выбранной недели
                let startOfWeek = moment(startDate).add((selectedWeek - 1) * daysInWeek, 'days');
                // Если массив transferredFromIds не пустой, находим минимальный ID и используем его для вычисления начальной даты
                if (transferredFromIds.length > 0) {
                    const minTransferredFromId = Math.min(...transferredFromIds);
                    startOfWeek = moment(startDate).add((minTransferredFromId - 1) * daysInWeek, 'days');
                }
                // Коррекция конечной даты в зависимости от количества объектов в массиве transferredFromIds
                let endOfWeek = moment(startOfWeek).add(daysInWeek - 1, 'days'); // Добавляем 6 дней для получения конечной даты недели
                transferredFromIds.forEach(() => {
                    endOfWeek = moment(endOfWeek).add(daysInWeek, 'days'); // Добавляем кол-во дней, равное длине массива transferredFromIds
                });
                // Если выбрана 4 неделя и нет переданных предыдущих недель (transferredFromIds), добавляем 2 дня к конечной дате
                if (selectedWeek === 4) {
                    endOfWeek = moment(endOfWeek).add(2, 'days');
                }
                // Форматируем даты в нужном формате
                const formattedStartDate = startOfWeek.format('YYYY-MM-DD');
                const formattedEndDate = endOfWeek.format('YYYY-MM-DD');
                // Выводим результаты
                this.counteDateFrom = moment(formattedStartDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
                this.counteDateTo = moment(formattedEndDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
                // console.log(formattedStartDate, formattedEndDate)
                this.getDataByOrder(formattedStartDate, formattedEndDate);
            },
            // Главный розыгрыш ..........................................................................................................................
            getMainEventData(week) {
                this.current_week = week;
                this.current_week_index = this.current_week - 1;
                console.log(week, this.current_week, this.current_week_index)
                if (this.weekDBarr[this.current_week_index].completed || this.weekDBarr[this.current_week_index].saved_result) {
                    if (this.weekDBarr[this.current_week_index].winners_result != undefined) {
                        this.draftWinnerDesck = this.weekDBarr[this.current_week_index].winners_result;
                    } else {
                        this.draftWinnerDesck = null;
                    }
                } else {
                    this.draftWinnerDesck = null;
                }
                this.counteDateFrom = moment(this.startDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
                this.counteDateTo = moment(this.endDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
                this.getDataByOrder(this.startDate, this.endDate);
                console.log('Неделя главного розыгрыша')
            },
            // end .......................................................................................................................................
            async getDataByOrder(fromDate, toDate) {
                // console.log(fromDate)
                // console.log(toDate)
                var codesArr = [];
                const codesQ = query(
                    collection(this.$db, "codes"), 
                    where("activate", "==", true),
                    // where("win_status", "==", false),
                    where("activate_date", ">=", fromDate),
                    where("activate_date", "<=", toDate),
                );
                // Build Data Array
                const snapshotCodesQuery = await getDocs(codesQ);
                snapshotCodesQuery.forEach((doc) => {
                    // doc.data() is never undefined for query doc snapshots
                    // console.log(doc.id, " => ", doc.data());
                    codesArr.push(doc.data());
                });
                this.codesOrderedArr = codesArr;
                console.log(this.codesOrderedArr)
                this.getUsersCounter();
                // Counter's
                const snapshotCodesCount = await getCountFromServer(codesQ);
                this.codesPerWeekCount = snapshotCodesCount.data().count;
                // console.log(codesArr, 'Массив кодов после фильтрации')
                if (this.current_week == 5) {
                    this.getCodesCount_correct(fromDate, toDate);
                }
            },
            async getCodesCount_correct(fromDate, toDate) {
                const codesQ = query(
                    collection(this.$db, "codes"), 
                    where("activate", "==", true),
                    where("win_status", "==", false),
                    where("activate_date", ">=", fromDate),
                    where("activate_date", "<=", toDate),
                );
                const snapshotCodesCount = await getCountFromServer(codesQ);
                this.codesPerWeekCount_coorect = snapshotCodesCount.data().count;
            },
            async getUsersCounter() {
                // console.log(this.codesOrderedArr, 'Массив кодов - функция юсера')
                const codesArr = this.codesOrderedArr;
                const usersIDsArr = [];
                const usersData = [];
                codesArr.forEach((code) => {
                    // doc.data() is never undefined for query doc snapshots
                    // console.log(doc.id, " => ", doc.data());
                    usersIDsArr.push(code.userID);
                });
                // console.log(usersIDsArr);
                const uniqueArr = this.uniqueById(usersIDsArr);
                this.usersPerWeekCount = uniqueArr.length;
                // this.usersPerWeekCount = 14

                // const usersQ = query(
                //     collection(this.$db, "users"), 
                //     where("user.ID", "in", uniqueArr)
                // );
                // ........................................................................Отложенный функционал Получение всех users из базы согласно ID's участников
                // console.log(uniqueArr);
                // const snapshotUsersQuery = await getDocs(usersQ);
                // snapshotUsersQuery.forEach((doc) => {
                //     // doc.data() is never undefined for query doc snapshots
                //     // console.log(doc.id, " => ", doc.data());
                //     usersData.push(doc.data());
                // });
                // this.usersOrderArr = usersData;
                // console.log(usersData, 'USERS  DATA')
            },
            uniqueById(array) {
                const uniqueIds = new Set();
                return array.filter(item => {
                    if (uniqueIds.has(item)) {
                        return false;
                    }
                    uniqueIds.add(item);
                    return true;
                });
            },
            // Перенос розыгрыша .........................................................................................................................
            movedJokeWeek(weekID) {
                const currentWeek = weekID;
                const targetWeek = weekID + 1;
                const weeksArr = this.weekDBarr;
                const weekDB_ID = this.getCurrentWeekID(currentWeek);
                const weekDB_ID_next = this.getCurrentWeekID(targetWeek);
                const curWeek = this.weekDBarr.filter((item) => {
                    return item.week_ID == weekID;
                })
                let currentTransferArr = curWeek[0].transferred_from; // Ensure it's initialized as an array
                console.log(currentTransferArr, 'TRANSFER')
                if (!Array.isArray(currentTransferArr)) {
                    currentTransferArr = [];
                }
                console.log(currentTransferArr, 'TRANSFER MIDDLE')
                currentTransferArr.push(currentWeek);
                console.log(currentTransferArr, 'TRANSFER FINAL')


                this.updateWeekDB_moved('updateCur', weekDB_ID);
                this.updateWeekDB_moved('updateNext', weekDB_ID_next, currentTransferArr);
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
                // this.getWeeksFromDB();
                

                console.log(currentWeek, targetWeek, weeksArr)
                console.log(curWeek, currentTransferArr)
            },
            async updateWeekDB_moved(param, id, arr) {
                const currentDate = this.generateCurrentDate();
                let dataUpdateArr = {};
                if (param == 'updateCur') {
                    dataUpdateArr = {
                        moved_next: true,
                        moved_date: currentDate
                    }
                } else {
                    dataUpdateArr = {
                        transferred_from: arr
                    }
                }
                const weekRef = doc(this.$db, "jokes", id);
                const weekSnap = await getDoc(weekRef);
                if (weekSnap.exists()) {
                    // console.log(id, weekSnap.data(), 'asdasdasda')
                    await updateDoc(weekRef, dataUpdateArr);
                } else {
                    // docSnap.data() will be undefined in this case
                    console.log("No such document!");
                }
            },
            // Проведение розыгрыша.......................................................................................................................
            initJokeMain() {
                console.log('main event joke');
                // this.selectMainWinner(this.codesOrderedArr, this.prizePollMain);
                const winners = this.selectMainWinner(this.codesOrderedArr, this.prizePollMain);
                this.draftWinnerDesck = [winners];
                console.log([winners]);
            },
            async initJokeWeek() {
                // console.log(this.current_week, 'INIT JOKE');
                // this.selectWinners(this.codesOrderedArr, this.prizePool);
                const winners = this.selectWinners(this.codesOrderedArr, this.prizePool);
                console.log(winners)
                this.draftWinnerDesck = winners;
                // console.log(winners, 'WINNERS');
            },
            selectWinners(codes, prizePool) {
                // Shuffle the codes array randomly
                const shuffledCodes = codes.sort(() => Math.random() - 0.5);
                const selectedPrizes = [];
                const selectedUserIDs = new Set();
                const mainCodes = [];
                const reserveCodes = [];
                // Count how many times each prize has been selected
                const prizeCounts = {
                    'Сертификат на 10 тысяч тенге в Magnum': 0,
                    'Сертификат на 20 тысяч тенге в Magnum': 0,
                    'Кухонный робот BORK': 0
                };

                // Get the transferred_from IDs for the current week
                const transferredFromIds = this.weekDBarr[this.current_week_index].transferred_from || [];

                const numberOfTransfers = transferredFromIds.length;

                // Helper function to check if a prize can still be assigned
                function canAssignPrize(prize) {
                    if (numberOfTransfers > 0) {
                        const prizeResult = prizeCounts[prize] < (prize === 'Кухонный робот BORK' ? 1 + numberOfTransfers : 3 + 3 * numberOfTransfers);
                        console.log(prizeResult)
                        return prizeResult
                    } else {
                        return prizeCounts[prize] < (prize === 'Кухонный робот BORK' ? 1 : 3);
                    }
                }

                

                for (const code of shuffledCodes) {
                    // Check if the code's userID has already been selected
                    if (selectedPrizes.some(prize => prize.code.userID === code.userID) ||
                        reserveCodes.some(reserveCode => reserveCode.userID === code.userID) ||
                        mainCodes.some(mainCode => mainCode.userID === code.userID)) {
                        continue; // Skip to the next code
                    }

                    // Choose a random prize
                    const randomPrizeIndex = Math.floor(Math.random() * prizePool.length);
                    const randomPrize = prizePool[randomPrizeIndex];

                    // Check if the chosen prize can still be assigned
                    if (!canAssignPrize(randomPrize)) {
                        continue; // Skip to the next code
                    }

                    // Update the prize count
                    prizeCounts[randomPrize]++;

                    // Add the code to the main codes array
                    mainCodes.push(code);

                    // Select two random reserve codes for the current user
                    const userReserveCodes = shuffledCodes.filter(c => c.userID !== code.userID && !selectedPrizes.some(prize => prize.reserveCodes.some(reserveCode => reserveCode.userID === c.userID)) && !mainCodes.some(mainCode => mainCode.userID === c.userID));
                    if (userReserveCodes.length >= 2) {
                        const reserveCodeIndices = this.getRandomIndices(userReserveCodes.length, 2);
                        reserveCodes.push(userReserveCodes[reserveCodeIndices[0]], userReserveCodes[reserveCodeIndices[1]]);
                        // Add the selected prize to the list
                        selectedPrizes.push({
                            code: code,
                            reserveCodes: [userReserveCodes[reserveCodeIndices[0]], userReserveCodes[reserveCodeIndices[1]]],
                            prize: randomPrize
                        });
                    }


                    // Determine the total number of prizes
                    const totalPrizes = transferredFromIds.length > 0 ? 7 + 7 * transferredFromIds.length : 7;
                    console.log(totalPrizes)
                    // Break out of the loop if 7 prizes are selected
                    if (selectedPrizes.length === totalPrizes) {
                        break;
                    }
                }

                // console.log(mainCodes);

                return this.shortWinnersArr(selectedPrizes);
            },
            selectMainWinner(codes, prizePool) {
                console.log(codes, prizePool)
                // Шаг 1: Отфильтровать массив кодов с win_status равным false
                const filteredCodes = codes.filter(code => !code.win_status);
                console.log(filteredCodes.length)

                // Шаг 2: Провести розыгрыш основного победителя
                // Создаем массив уникальных userID из оставшихся кодов
                const uniqueUserIDs = [...new Set(filteredCodes.map(code => code.userID))];
                // Выбираем случайный уникальный код основного победителя
                const mainWinnerUserID = uniqueUserIDs[Math.floor(Math.random() * uniqueUserIDs.length)];
                const mainWinnerCode = filteredCodes.find(code => code.userID === mainWinnerUserID);

                // Шаг 3: Найти два резервных уникальных кода
                // Удаляем из уникальных userID код победителя
                const reserveUserIDs = uniqueUserIDs.filter(userID => userID !== mainWinnerUserID);
                // Создаем массив доступных резервных кодов
                const availableReserveCodes = filteredCodes.filter(code => reserveUserIDs.includes(code.userID));
                // Выбираем два случайных резервных кода из доступных
                const reserveWinnerCodes = [];
                const chosenUserIDs = []; // Массив для отслеживания уже выбранных userID
                for (let i = 0; i < 2 && i < availableReserveCodes.length; i++) {
                    // Фильтруем доступные резервные коды по userID, чтобы не повторять выбор кодов для одного и того же пользователя
                    const availableCodesForSelection = availableReserveCodes.filter(code => !chosenUserIDs.includes(code.userID));
                    const randomIndex = Math.floor(Math.random() * availableCodesForSelection.length);
                    const chosenCode = availableCodesForSelection[randomIndex];
                    reserveWinnerCodes.push(chosenCode);
                    chosenUserIDs.push(chosenCode.userID);
                }

                // Возвращаем результаты
                return {
                    code: mainWinnerCode,
                    reserveCodes: reserveWinnerCodes,
                    prize: prizePool[0],
                };
            },
            // OLD OLD
            shortWinnersArr(arr) {
                // Создаем объект для сопоставления призов с их порядковыми номерами
                const prizePool = this.prizePool;
                const prizeIndex = {};
                prizePool.forEach((prize, index) => {
                    prizeIndex[prize] = index;
                });

                // Сортируем массив codes на основе порядка, определенного в prizePool
                arr.sort((a, b) => {
                    const prizeA = a.prize;
                    const prizeB = b.prize;
                    return prizeIndex[prizeA] - prizeIndex[prizeB];
                });

                return arr;
            },
            // Сохранение розыгрыша
            async saveJokeRes_PRE() {
                if (confirm("Вы уверены, что хотите СОХРАНИТЬ розыгрыш?")) {
                    // Действие при нажатии на кнопку "Да"
                    console.log("Действие выполнено");
                    // FUNCTION VARS
                    var _self = this;
                    const winnersResult = this.draftWinnerDesck;
                    const currentDate = this.generateCurrentDate();
                    const weekID = this.getCurrentWeekID(this.current_week);
                    // UPDATE JOKES COLLECTION
                    const weekRef = doc(this.$db, "jokes", weekID);
                    const weekSnap = await getDoc(weekRef);
                    if (weekSnap.exists()) {
                        console.log(weekID, weekSnap.data(), 'asdasdasda')
                        await updateDoc(weekRef, {
                            saved_result: true,
                            winners_result: winnersResult,
                        });
                        this.getWeeksFromDB();
                    } else {
                    // docSnap.data() will be undefined in this case
                        console.log("No such document!");
                    }
                    // END UPDATE JOKES COLLECTION
                } else {
                    // Действие при нажатии на кнопку "Нет"
                    console.log("Действие отменено");
                }
            },
            // Публикация розыгрыша.......................................................................................................................
            async saveJokeResult() {
                if (confirm("Вы уверены, что хотите ОПУБЛИКОВАТЬ розыгрыш? \nОтменить розыгрыш будет невозможно!")) {
                    // Действие при нажатии на кнопку "Да"
                    console.log("Действие выполнено");
                    // FUNCTION VARS
                    var _self = this;
                    const winnersResult = this.draftWinnerDesck;
                    const currentDate = this.generateCurrentDate();
                    const weekID = this.getCurrentWeekID(this.current_week);
                    // UPDATE JOKES COLLECTION
                    const weekRef = doc(this.$db, "jokes", weekID);
                    const weekSnap = await getDoc(weekRef);
                    if (weekSnap.exists()) {
                        console.log(weekID, weekSnap.data(), 'asdasdasda')
                        await updateDoc(weekRef, {
                            completed: true,
                            completed_date: currentDate,
                            // winners_result: winnersResult,
                        });
                        this.getWeeksFromDB();
                        this.updateCodesStatus(winnersResult, currentDate);
                    } else {
                    // docSnap.data() will be undefined in this case
                        console.log("No such document!");
                    }
                    // END UPDATE JOKES COLLECTION
                } else {
                    // Действие при нажатии на кнопку "Нет"
                    console.log("Действие отменено");
                }
            },
            updateCodesStatus(resultArr, currentDate) {
                const codes = [];
                resultArr.forEach(async (item) => {
                    const codeRef = doc(this.$db, "codes", item.code.code);
                    await updateDoc(codeRef, {
                        win_status: true,
                        win_week_ID: this.current_week,
                        win_prize: item.prize,
                        win_date: currentDate,
                    });
                    // codes.push(item.code.code);
                });
                // console.log(codes, 'КОДЫ ПОСЛЕ ПАРСА')
                // this.usersOrderArr = usersData;
            },
            // Функции обработчики, коррекция данных......................................................................................................
            getCurrentWeekID(curWeek) {
                if (curWeek >= 1 && curWeek <= 5) {
                    switch (curWeek) {
                        case 1:
                            return "week_one";
                        case 2:
                            return "week_two";
                        case 3:
                            return "week_three";
                        case 4:
                            return "week_four";
                        case 5:
                            return "week_five";
                    }
                } else {
                    return "Unknown week";
                }
            },
            generateCurrentDate() {
                const currentDate = new Date();
                const day = String(currentDate.getDate()).padStart(2, '0');
                const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
                const year = currentDate.getFullYear();
                const formattedDate = `${year}-${month}-${day}`;
                return formattedDate;
            },
            getRandomIndices(length, count) {
                const indices = Array.from({ length: length }, (_, i) => i);
                for (let i = length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [indices[i], indices[j]] = [indices[j], indices[i]];
                }
                return indices.slice(0, count);
            },

            // addJokesData() {
            //     const dataArr = {
            //         week_ID: 5,
            //         completed: false,
            //         moved_next: false,
            //         name: "5 НЕДЕЛЯ",
            //         name_kz : "5 АПТА",
            //     };
            //     try {
            //         const docRef = setDoc(doc(this.$db, "jokes", 'week_five'), dataArr);
            //         console.log("Joke written with ID: ", docRef.id);                    
            //     } catch (e) {
            //         console.error("Error adding joke: ", e);
            //     }
            // }

            // dateFormate(dateDB) {
            //     if (moment(dateDB).format('YYYY-MM-DD') == 'Invalid date') {
            //         console.log(true)
            //         console.log(dateDB, 'date')
            //         console.log(moment(dateDB).format('YYYY-MM-DD'), '---- FORMAT')
            //         const formattedDate = moment(dateDB, 'DD.MM.YYYY').format('YYYY-MM-DD');
            //         console.log(formattedDate)
            //         return formattedDate;
            //     } else {
            //         return dateDB;
            //         // console.log(false)
            //     }
            //     // if (dateDB == 'Invalid date') {
            //     //     return '2024-03-27'
            //     // } else {
            //     //     // const formattedDate = moment(dateDB, 'DD.MM.YYYY').format('YYYY-MM-DD');
            //     //     // console.log(formattedDate);
            //     //     return dateDB;
            //     // }
            // },

            // async updateDB() {
            //     var _self = this;
            //     const codesQ = query(
            //         collection(this.$db, "codes"), 
            //         where("activate", "==", true)
            //     );
            //     const snapshotCodesQuery = await getDocs(codesQ);
            //     snapshotCodesQuery.forEach(async (document)=> {
            //         const codeRef = doc(_self.$db, "codes", document.id);
            //         const newData = _self.dateFormate(document.data().activate_date);
            //         await updateDoc(codeRef, {
            //             activate_date: newData,
            //         });
            //         console.log(document.id, " => ", newData);
            //         // doc.data() is never undefined for query doc snapshots
            //         // await updateDoc(codeRef, {
            //         //     activate_date: newData,
            //         // });
            //         // codesArr.push(doc.data());
            //     });
            // }

            // Loop until 7 prizes are selected
                // for (const code of shuffledCodes) {
                //     // Choose a random prize
                //     let randomPrizeIndex = Math.floor(Math.random() * prizePool.length);
                //     let randomPrize = prizePool[randomPrizeIndex];

                //     // Check if the chosen prize can still be assigned
                //     while (!canAssignPrize(randomPrize)) {
                //         randomPrizeIndex = Math.floor(Math.random() * prizePool.length);
                //         randomPrize = prizePool[randomPrizeIndex];
                //     }

                //     // Update the prize count
                //     prizeCounts[randomPrize]++;

                //     // Find two random codes with different userIDs
                //     const reserveCodes = [];
                //     const selectedUserIDs = new Set();
                //     selectedUserIDs.add(code.userID); // Add the main code's userID
                //     while (reserveCodes.length < 2) {
                //         const randomCodeIndex = Math.floor(Math.random() * codes.length);
                //         const randomCode = codes[randomCodeIndex];
                //         if (randomCode.userID !== code.userID && !selectedUserIDs.has(randomCode.userID)) {
                //             reserveCodes.push(randomCode);
                //             selectedUserIDs.add(randomCode.userID);
                //         }
                //     }

                //     // Add the selected prize to the list
                //     selectedPrizes.push({
                //         code: code,
                //         reserveCodes: reserveCodes,
                //         prize: randomPrize
                //     });

                //     // Break out of the loop if 7 prizes are selected
                //     if (selectedPrizes.length === 7) {
                //         break;
                //     }
                // }
        },
        // beforeRouteEnter (to, from, next) {
        //     const adminLocalState = localStorage.getItem('adminArrData');
        //     if (adminLocalState == null) {
        //         next('/admin/auth')
        //     } else {
        //         next();
        //     }
        // },
        beforeCreate() {
            document.body.dataset.page = 'admin-page-jokes';
        },
        created () {
            this.getWeeksFromDB();
        },
        mounted() {
            // this.current_week = this.getCurrentWeek(this.startDate);
            // this.getDataByWeek(this.current_week);
            // this.addJokesData();
            // this.updateDB();
            // this.getDataByWeek(this.startDate);
        }
    }
</script>


<style lang="scss">
    @import '@/styles/components/admin/admin-page.scss';
    @import '@/styles/components/admin/admin-jokes.scss';
</style>